import React, { useState, useEffect, useContext } from 'react';
import { useParams } from "react-router-dom";
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import { Box, Button, Collapse, Typography, useTheme, Grid, Divider, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Paper, IconButton, styled } from "@mui/material";
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
  GridEditInputCell,
} from '@mui/x-data-grid';
import {
  randomCreatedDate,
  randomTraderName,
  randomId,
  randomArrayItem,
} from '@mui/x-data-grid-generator';
import DataGridCustomToolbar from '../../components/DataGridCustomToolbar';
import Header from "../../components/Header";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import FERCRiskEquationLong from './images/FERCRiskEquationLong.png';
// import { AssessmentContext } from '../SecurityGroup1';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';



const Threats = ({activeStep, setActiveStep, questionFamily, setQuestionFamily}) =>  {
  const [rows, setRows] = React.useState();
  const [rowModesModel, setRowModesModel] = React.useState({});
  const theme = useTheme();
  const axiosPrivate = useAxiosPrivate();

  const date = new Date();
  const currentYear = date.getFullYear();

  const [threatToDelete, setThreatToDelete] = useState(null);
  const [threatName, setThreatName] = useState(null);

  const [open, setOpen] = useState(false);
  const [userAddedThreatTemp , setUserAddedThreatTemp] = useState("Nation State");
  const [openInstructions, setOpenInstructions] = useState(true);

  const {assessmentID} = useParams();
  const [refresh, setRefresh] = useState(true);
  // const [assessmentID2, userId] = useContext(AssessmentContext);


   // Get Critical Assets Function.  This should pull cyberAssets for the current assessment. 
const getThreats = async () => {
  try {
    const response = await axiosPrivate.get(`/threats/threats/${assessmentID}`, {
        withCredentials: true
    });
    const data = await response.data;
    setRows(data);
    // if (data.length===0) {
    //   setRows(DefaultThreatsList);
    // } else {
    //   setRows(data);
    // }
    console.log(data);
  } catch (err) {
    // alert("Login Expired.");
    console.error(err);
    // navigate('/login', { state: { from: location }, replace: true });
  }
};




const DefaultThreatsList = [
 {
  _id: "threat01",
  threatActor: "Nation States",
  description: "",
  example: ""
},
{
  _id: "threat02",
  threatActor: "Criminal Organizations",
  description: "",
  example: ""
},
{
  _id: "threat03",
  threatActor: "Terrorist Groups",
  description: "",
  example: ""
},
{
  _id: "threat04",
  threatActor: "Activist Groups",
  description: "",
  example: ""
},
{
  _id: "threat05",
  threatActor: "Insider Threat",
  description: "",
  example: ""
},
{
  _id: "threat06",
  threatActor: "Natural Hazards",
  description: "",
  example: ""
},

]

const AddDefaultThreats = () => {
  setRows(rows.concat(DefaultThreatsList));
}

  useEffect(() => {
      getThreats();
    }, [refresh]);  // eslint-disable-line react-hooks/exhaustive-deps
    if (!rows) {
      return null;
    }

  
  // Update Database Function 
  const handleAddRow = async () => {
    const id = randomId();
    let threatName = 'CHANGE ME';
    let threatDescription = 'ADD DESCRIPTION;'
    setRows((oldRows) => [...oldRows, { '_id': id, threatName: 'CHANGE ME', threatDescription: 'ADD DESCRIPTION', isNew: true }]);
    setRowModesModel((oldModel) => ({
      ...oldModel,
      [id]: { mode: GridRowModes.Edit, fieldToFocus: 'name' },
    }));
    let active = true;
    try {
      const response = await axiosPrivate.post(`/threats/threats/new`,
        JSON.stringify({ assessmentID, threatName, threatDescription, active }),
      {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true
      } 
    );
    } catch (err) {
        console.log(err);
    }
  }

  const handleRowEditStop = (id, event) => {
    if (id.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (row) => () => {
    setRowModesModel({ ...rowModesModel, [row._id]: { mode: GridRowModes.Edit } });
  };

  // Update Database Function 
  const handleThreatUpdate = async (updatedRow) => {
    let id = updatedRow._id;
    let threatName = updatedRow.threatName;
    let threatDescription = updatedRow.threatDescription;
    try {
      const response = await axiosPrivate.patch(`/threats/threats/${id}`,
        JSON.stringify({ assessmentID, threatName, threatDescription }),
        {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }
        );
        const data = await response.data;
        // Axios provides responses in JSON by default. The response JSON is always named 'data'. 
        // The console log commands below allow you to see the responses from Axios for the response.  
        // navigate(from, { replace: true });
      } catch (err) {
        if (!err?.response) {
            console.log('No Server Response');
        } else {
            console.log('Action Failed')
        }
      }
    };

  const handleSaveClick = (row) => {
    setRowModesModel({ ...rowModesModel, [row._id]: { mode: GridRowModes.View } });
  };

  const handleDeleteClick = (id) => () => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row._id === id);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row._id === newRow._id ? updatedRow : row)));
    handleThreatUpdate(updatedRow);
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handleDeleteThreat = async () => {
    try {
        const response = await axiosPrivate.delete(`/threats/${threatToDelete}`, 
            ({ "active": false }),
          {
              headers: { 'Content-Type': 'application/json' },
              withCredentials: true
          }
      );
        if (response.data.success) {
            alert(response.data.msg);
        } 
        // console.log(response);
    } catch (err) {
        console.error(err);
    }
     setThreatToDelete(null);
     setThreatName(null);
     setRefresh(!refresh);
 }
 
const handleClickOpen = (params) => {
  setThreatToDelete(params.row._id);
  setThreatName(params.row.assetName || "this device");
  setOpen(true);
};

const handleNo = () => {
  setOpen(false);
};

const handleYes = () => {
  handleDeleteThreat();
  setOpen(false);
};

const columns = [
  {
    field: "threatName",
    headerName: "Name",
    flex: 1,
    editable: true
  },
  {
    field: "threatDescription",
    headerName: "Description",
    flex: 1,
    editable: true
  },
  {
    field: 'actions',
    type: 'actions',
    headerName: 'Actions',
    flex: 1,
    cellClassName: 'actions',
    getActions: (params) => {
      const isInEditMode = rowModesModel[params.row._id]?.mode === GridRowModes.Edit;

      if (isInEditMode) {
        return [
          <GridActionsCellItem
            icon={<SaveIcon />}
            label="Save"
            sx={{
              color: 'primary.main',
            }}
            onClick={() => handleSaveClick(params.row)}
          />,
          <GridActionsCellItem
            icon={<CancelIcon />}
            label="Cancel"
            className="textPrimary"
            onClick={handleCancelClick(params.row._id)}
            color="inherit"
          />,
        ];
      }

      return [
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Edit"
          className="textPrimary"
          onClick={handleEditClick(params.row)}
          color="inherit"
        />,
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Delete"
          onClick={() => handleClickOpen(params)}
          color="inherit"
        />,
        <GridActionsCellItem
          icon={<AddIcon />}
          label="Add"
          onClick={() => handleAddRow()}
          color="inherit"
        />
      ];
    },
  },
];


const handleAddNewThreat = async () => {
  if (userAddedThreatTemp.length>1) {
    let threatName = userAddedThreatTemp;
    let active = true;
    try {
      const response = await axiosPrivate.post(`/threats/threats/new`,
        JSON.stringify({ assessmentID, threatName, active }),
      {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true
      } 
    );
    } catch (err) {
        console.log(err);
        
    }
  }
  setUserAddedThreatTemp("");
  setRefresh(!refresh);
};

const handleOpenInstructions = () => {
  setOpenInstructions(!openInstructions);
};

const handleNextQuestion = () => {
  if (questionFamily === 3) {
    setQuestionFamily(1);
  } else {
    setQuestionFamily(questionFamily+1);
  }
};

 const HtmlTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
      ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
          backgroundColor: '#f5f5f9',
          color: 'rgba(0, 0, 0, 0.87)',
          maxWidth: 500,
          fontSize: theme.typography.pxToRem(16),
          border: '1px solid #dadde9',
        },
      }));


  return (
    <Box sx={{ marginTop:'1em', flexGrow: 1 }}>
      <Header title='Threats' subtitle='Add threat actors for this assessment.' />
      <Grid container spacing={2}>
        {/* <Grid item size={5}>
          <Header title='Threats' subtitle='Add Threats for this assessment.' />
        </Grid>
        <Grid item size={5}>
          <Box
            sx={{ pt:'0.5rem', minWidth:'350px' }}
            component="img"
            width="80%"
            alt="The house from the offer."
            src={FERCRiskEquationLong}
            />
        </Grid> */}
      
        <Grid item size={12} >
        <Paper sx={{ backgroundImage: "none", backgroundColor: theme.palette.background.alt, borderRadius: "0.55rem", mr:'0.55rem', p:'4px'}} >
          <Grid item xs={12}>
          {openInstructions ? (
              <IconButton color="primary"  aria-label="open or close instructions" onClick={handleOpenInstructions} >
                <ExpandCircleDownIcon sx={{ transform: 'rotate(180deg)'}} color='primary' fontSize="large" />
                <Typography variant='h3' sx={{ ml: '1.5rem' }}><u>Instructions</u>:</Typography>
              </IconButton>
                ) : (
                <IconButton color="primary"  aria-label="open or close detection and response" onClick={handleOpenInstructions} >
                  <ExpandCircleDownIcon color='primary' fontSize="large" />
                  <Typography variant='h3' sx={{ ml: '1.5rem' }}>Instructions</Typography>
                </IconButton>
                )}
                <Divider sx={{ border:0.5, mt:'6px' }}/>
          </Grid>
          <Collapse in={openInstructions} timeout="auto" unmountOnExit>
            <Grid container spacing={1}>
              <Grid item size={12} sx={{ ml:'2rem' }}>
                <Typography>Enter the name of the threat and press the <AddCircleIcon color="primary" /> to add it to the assessment.</Typography>
                <Typography>Click on the <DeleteIcon sx={{ cursor:'text' }}  /> to remove a threat. Click on the <EditIcon sx={{ cursor:'text' }}  /> to make changes to the threats and click the <SaveIcon sx={{ cursor:'text'}} /> to save the changes.</Typography>
                <Typography>This information is necessary to complete the vulnerability assessment.</Typography>
                <Typography>This information is included in the final Site Security Plan.</Typography>
              </Grid>
            </Grid>
          </Collapse>
        </Paper>
        </Grid>

        {/* <Grid item size={12}>
          <Button sx={{ minWidth:'100px', width:'10%', display:'block', ml:'auto', mr:'5%' }} variant="contained" onClick={handleNextQuestion}>Next</Button>
        </Grid> */}

        <Grid item size={12}>
          <Paper sx={{ backgroundImage: "none", backgroundColor: theme.palette.background.alt, borderRadius: "0.55rem", mr:'0.55rem', mt:'1rem', p:'4px', minHeight:'250px'}} >
              {/* <Typography display="inline" sx={{ fontSize:'1.5em', marginTop:'0.5em', p:'0.5em'  }}>Threats:</Typography> */}
                <input style={{ height: '40px', width: '40%', marginLeft: '2rem' }}
                  type="text"
                  id="userAddedUserTemp"
                  onChange={(e) => setUserAddedThreatTemp(e.target.value)}
                />
                <select style={{ height: '40px', width: '40%', marginLeft: '2rem'}} onChange={(e) => setUserAddedThreatTemp(e.target.value)}> 
                  {DefaultThreatsList.map((threat) => (
                    <option key={threat.threatActor} value={threat.threatActor}>
                      <HtmlTooltip placement="right-start" title={
                    <React.Fragment>
                    {threat.familyDescription} TETS<br />
                    </React.Fragment>} 
                    >
                      {threat.threatActor}
                </HtmlTooltip>
                {/* {threat.ClassID} {threat.Class} */}
                </option>
                  ))}
               </select> 
                <IconButton color="primary"  aria-label="add a vulnerability" onClick={handleAddNewThreat}>
                  <AddCircleIcon fontSize="large" />
                </IconButton>
              <Grid item size={12} >
                <Dialog
                  open={open}
                  onClose={handleNo}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  >
                  <DialogTitle id="alert-dialog-title">
                  {"Verify Delete Command"}
                  </DialogTitle>
                  <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                      Are you sure you want to delete {threatName}?
                  </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                  <Button onClick={handleYes}>Yes</Button>
                  <Button onClick={handleNo} autoFocus>
                      No
                  </Button>
                  </DialogActions>
                </Dialog>
                <Box
                  sx={{
                    width: '99%',
                    fontSize: '1em',
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: theme.palette.secondary.alt,
                        color: theme.palette.secondary[100],
                        borderBottom: "solid 2px black",
                        borderTop: "solid 2px black",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: theme.palette.primary.light,
                    },
                    "& .MuiDataGrid-footerContainer": {
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary[100],
                        borderTop: "none"
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                        color: `${theme.palette.secondary[200]} !important`,
                    },
                    // "& .MuiDataGrid-main": {
                    //   fontSize: "1.5em"
                    // }
                  }}
                  >
                  <DataGrid
                    rows={rows || []} 
                    getRowId={(row) => row._id}
                    columns={columns}
                    editMode="row"
                    rowModesModel={rowModesModel}
                    onRowModesModelChange={handleRowModesModelChange}
                    onRowEditStop={handleRowEditStop}
                    processRowUpdate={processRowUpdate}
                    slots={{
                      toolbar: DataGridCustomToolbar,
                    }}
                    slotProps={{
                      toolbar: { setRows, setRowModesModel },
                    }}
                  />
                </Box>
                
              </Grid>
        </Paper>
        </Grid>
        </Grid>
    </Box>
  );
}

export default Threats